import React from 'react';

const UserLogo = (props) => {
	return (
		<div class="user_logo mod_align_center">
			<svg width="30px" height="30px" viewBox="0 0 30 30">
				<g>
					<path d="M12.68,19.6c0.21-0.56,0.36-1.2,0.36-1.91c-1.16-0.67-2.19-2.29-2.8-4.2H9.92c-0.45,0-0.82-0.36-0.82-0.81v-1.12c0-0.37,0.25-0.67,0.6-0.76C9.42,7.43,10.72,4.14,15,4.14c4.28,0,5.58,3.29,5.3,6.67c0.34,0.1,0.6,0.39,0.6,0.76v1.12c0,0.45-0.37,0.81-0.82,0.81h-0.32c-0.61,1.9-1.64,3.53-2.8,4.2c0,0.7,0.15,1.34,0.36,1.91c3.41,0.61,5.79,2.5,7.33,4.09C26.72,21.39,28,18.35,28,15c0-7.18-5.82-13-13-13S2,7.82,2,15c0,3.35,1.28,6.39,3.35,8.69C6.89,22.1,9.27,20.22,12.68,19.6z"/>
				</g>
			</svg>
		</div>
	)
}

export default UserLogo;